// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".transition-1[data-v-310d3893] {\n  transition-delay: 1s;\n}\n.span-expand[data-v-310d3893] {\n  display: block;\n  width: 100%;\n  height: 100%;\n}", ""]);
// Exports
module.exports = exports;
